import { render } from "./FreeText.vue?vue&type=template&id=751c50ea&scoped=true"
import script from "./FreeText.vue?vue&type=script&lang=js"
export * from "./FreeText.vue?vue&type=script&lang=js"

import "./FreeText.vue?vue&type=style&index=0&id=751c50ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751c50ea"]])

export default __exports__